import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import React from 'react'
import PBAPIClient from '../../../../../services/prime-client'
import { getCookie } from '../../../../../utilities/functions'

const useTradingAccounts = (id) => {


    const authToken = getCookie("authToken")
    const companyId = getCookie("companyId")
    const userType = getCookie("userType")
    const userId = getCookie("userId")

    console.log("USERTYPE", userId)


    const idToUse = userType === "under-company" ? userId : companyId;


    const apiClient = new PBAPIClient(`/account/${userType === "under-company" ? "under-company" : "company"}`, authToken)

    return useQuery({
        queryKey: ["accounts", idToUse],
        queryFn: () => apiClient.get(idToUse),
        staleTime: ms("1h"),
        enabled: !!idToUse
    })
}

export default useTradingAccounts